<template>
	<div class="underlying-funds">
		<underlying-funds :widget-data="widgetData" :vehicle-id="$route.params.vehicleId">
			<template #superscript1>
				<disclosure-superscript
					class="detail-page"
					anchor="underlyingFunds"
					:statistics="['fundAllocationTDUnderlying']"
				/>
			</template>
			<template #superscript2>
				<disclosure-superscript
					class="detail-page"
					anchor="underlyingFunds_cashEquivalents"
					:statistics="$getDynamicStatisticsForAnchorByObjective['underlyingFunds_cashEquivalents']"
				/>
			</template>
		</underlying-funds>
	</div>
</template>

<script>
import UnderlyingFunds from './underlying-funds/UnderlyingFunds';
import UnderlyingFundsDataMixin from '_mixins_/UnderlyingFundsDataMixin';
import SuperscriptMixin from '../mixins/SuperscriptMixin';
export default {
	name: 'UnderlyingFundsWrapper',
	components: {
		'underlying-funds': UnderlyingFunds
	},
	mixins: [UnderlyingFundsDataMixin, SuperscriptMixin]
};
</script>

<style lang="less">
@import "~_css_/module.less";
.underlying-fund {
	.chart {
		height: 98.5px;
		width: 98.5px;
	}
	.chart-legend {
		border-spacing: 0;
		width: 100%;
		.each-row {
			position: relative;
			display: flex;
		}
		.colored-square {
			position: absolute;
			left: -20px;
			top: 5px;
		}
		th {
			border-bottom: 1px solid #ccc;
			color: #666;
			display: inline-block;
			font-family: "AvenirNextLTW01-Regular", sans-serif;
			font-size: 12px;
			padding: 5px 0;
			margin: 0 0 0 20px;
			width: 93%;
		}
		.content.no-border {
			border: none;
		}
		.objective {
			float: left;
			clear: left;
			color: #333;
			font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
			font-size: 14px;
			font-weight: 400;
			padding-top: 3px;
			flex-grow: 1;
		}
		.fund-name {
			float: left;
			clear: left;
			color: #1d5799;
			text-decoration: none;
			font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
			font-size: 12px;
			font-weight: 400;
			width: 85%;
			padding: 4px 0;
			display: inline-block;
		}
		.total-value {
			color: #333;
			float: right;
			clear: right;
			font-size: 14px;
			font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
			font-weight: 400;
			padding-top: 3px;
			text-align: right;
			min-width: max-content;
			margin-left: 10px;
		}
		.sub-value {
			color: #333;
			float: right;
			clear: right;
			font-size: 12px;
			font-family: "AvenirNextLTW01-Regular", sans-serif;
			font-weight: 400;
			text-align: right;
			width: 15%;
			padding: 4px 0;
		}
	}
	.adjust-date {
		margin-left: 21px;
		margin-top: 15px;
	}
	@media (max-width: 480px) {
		.col-sm-8 {
			width: 100%;
		}
	}
}
</style>
